export default __webpack_public_path__ + "static/media/alula-logo-for-geoarm-security-home.d258ff0d.jpg";